module.exports = __webpack_public_path__ + "img/TH.3c76cb49.gif";